export default __webpack_public_path__ + "5dc5f606615c119072e28885ceea7d29.svg";